import { QueryState } from '../state';

/**
 * Copies the search, sort, columns and fields from the shared query to the query.
 * Search, sort and fields/columns are shared between the query and the shared query because it's part of the table toolbar & header.
 * Pagination is not shared because it's part of the table body.
 */
export function syncWithSharedQuery(
  query: QueryState<{}>,
  sharedQuery: QueryState<{}>,
) {
  query._filters.search = sharedQuery._filters.search;
  query.sort = sharedQuery.sort;
  query._columns = sharedQuery._columns;
  query._fields = sharedQuery._fields;
}
